import { render, staticRenderFns } from "./GifCodeNotification.vue?vue&type=template&id=72c1c2d0&scoped=true&"
import script from "./GifCodeNotification.vue?vue&type=script&lang=js&"
export * from "./GifCodeNotification.vue?vue&type=script&lang=js&"
import style0 from "./GifCodeNotification.vue?vue&type=style&index=0&id=72c1c2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c1c2d0",
  null
  
)

export default component.exports